import * as React from "react";
import { imagens } from "../../Func_genericas/valores_estaticos";


export default function LoadingVulpes() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <img
        src={imagens.loader_gif}
        alt="Loading"
        style={{ width: "180px", height: "220px" }}
      />
    </div>
  );
}
